<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chiGoldberg0008#acknow">Acknowledgments</a></p>
<p class="tocf"><a class="xref" href="#/chiGoldberg0009#ch01">1  Introduction</a></p>
<p class="toc"><a class="xref" href="#/chiGoldberg0010#ch02">2  The French Tradition: 1789 and the Jews</a></p>
<p class="toc"><a class="xref" href="#/chiGoldberg0011#ch03">3  The German Tradition: Capitalism and the Jews</a></p>
<p class="toc"><a class="xref" href="#/chiGoldberg0012#ch04">4  The American Tradition: The City and the Jews</a></p>
<p class="toc"><a class="xref" href="#/chiGoldberg0013#ch05">5  Conclusions</a></p>
<p class="tocbmf"><a class="xref" href="#/chiGoldberg0014#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiGoldberg0016#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chiGoldberg0017#index">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Goldberg-0007.vue?114d0d02